import DropdownDocumentResult from "./components/DropdownDocumentResult";
import DropdownTextResult from "./components/DropdownTextResult";

export default {
    'default': DropdownTextResult,
    'download': DropdownDocumentResult
};
